import type { AxiosRequestConfig } from 'axios';

import type { IFileProps } from '~/types';

import { api } from './api';

interface IUploadRequest {
  file: IFileProps;
  onUploadProgress: AxiosRequestConfig['onUploadProgress'];
}

function upload({
  file,
  onUploadProgress,
}: IUploadRequest): Promise<IFileProps> {
  const formData = new FormData();
  formData.append('blob[file]', file);

  return api.post('/blobs', formData, {
    onUploadProgress,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const uploaderApi = {
  upload,
} as const;
